module.exports = __webpack_public_path__ + "static/img/news-21.753387f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article/news-21.jpg
// module id = tFE8
// module chunks = 4